<template>
  <div class="index" v-if="isGetData">
    <nav-left></nav-left>
    <div class="container">
      <top-header></top-header>
      <router-view class="content-box" />
    </div>
  </div>
</template>

<script>
import navLeft from "@/components/navLeft.vue";
import topHeader from "@/components/topHeader.vue";
import { getShopInfo, getShopNotices } from "@/api/index.js";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      isGetData: false,
    };
  },
  components: {
    navLeft,
    topHeader,
  },
  created() {
    getShopInfo().then((res) => {
      if (res.code == 1) {
        if (!res.data.edcShopType) {
          this.$router.push({
            path: "/platformSelection",
          });
          return;
        }
        this.updateShopInfo(res.data);
        this.isGetData = true;
      }
    });
    if (this.$route.path != "/") {
      getShopNotices().then((res) => {
        if (res.code == 1) {
          this.updateMessage(res.data);
        }
      });
    }
  },
  methods: {
    ...mapActions(["updateShopInfo", "updateMessage"]),
  },
};
</script>

<style lang="less" scoped>
.index {
  display: flex;
  height: 100%;
  .container {
    flex: 1;
    margin-left: 180px;
    min-width: 800px;
    .content-box {
      background-image: url(../assets/img/bg-global.png);
      background-size: 100% 100%;
      height: calc(100% - 71px);
      .top-bar {
        display: none;
      }
    }
  }
}
</style>

<style lang="less">
.index {
  .container {
    .content-box {
      .tab-header {
        background-color: transparent;
      }
    }
  }
}
</style>
